import { useCallback } from 'react'
import useTwinTranslation from '../../../utils/hooks/useTwinTranslation'
import ModalDeleteFilled from '../ModalDeleteFilled'
import { twinFetchPostJSON } from '../../../utils/globals/data'
import { deleteBottomNavAppElement, signOutUser } from '../../../utils/reducers/reduxDispatch'
import { TwinDictionary } from '../../../utils/globals/dictionary'

interface ModalWorkingAntiLogoutProps extends ModalWorkingAntiLogoutLogicProps {
    setModalBlockSignOut: React.Dispatch<React.SetStateAction<TwinDictionary | null>>
 }

const ModalWorkingAntiLogout: React.FC<ModalWorkingAntiLogoutProps> = ({ setModalBlockSignOut, extraData }) => {
    const { onAcceptGoOut } = useModalWorkingAntiLogoutLogic({ extraData, setModalBlockSignOut })
    const { t, tVars } = useTwinTranslation()
    const options = { TaskId: extraData?.TaskId || '' }
    return (
        <ModalDeleteFilled className='text-gray-51' translations={{
            title: tVars('youAreWorkingInTask', 'Estás trabajando en la tarea #{{TaskId}}', options),
            subtitle: tVars('mustStopWorkingTaskToLogout', 'Debes parar de trabajar en la tarea #{{TaskId}} para poder cerrar sesión', options),
            buttonAccept: t('stopWorkingAndLogout', 'Parar y cerrar sesión'),
            buttonCancel: t('keepHere', 'Permancer')
        }} opened={true} setOpened={()=>setModalBlockSignOut(null)} onCancel={()=>setModalBlockSignOut(null)} onAccept={onAcceptGoOut} onClickOut={false} />
    )
}

interface ModalWorkingAntiLogoutLogicProps {
    extraData: TwinDictionary
    setModalBlockSignOut: React.Dispatch<React.SetStateAction<TwinDictionary | null>>
 }

const useModalWorkingAntiLogoutLogic = ({ extraData, setModalBlockSignOut }: ModalWorkingAntiLogoutLogicProps) => {
    const onAcceptGoOut = useCallback(async () => {
        if (extraData){
            const { TaskId, id, TaskBagOfHoursId, startDate } = extraData
            const endDate = new Date()
            const parsedStartDate = new Date(startDate).getTime()
            const now = new Date()
            const workedSecs = Math.round(Math.abs(parsedStartDate - now.getTime()) / 1000)
            const res = await twinFetchPostJSON('/api/app/task/workLog/endTaskWorkLog', { id, TaskId, endDate: endDate.toISOString(), workedSecs, TaskBagOfHoursId })
            if(res.endDate){
                await deleteBottomNavAppElement('workingModal')
                setModalBlockSignOut(null)
                signOutUser()
            }
        }
    }, [extraData, setModalBlockSignOut])
    return { onAcceptGoOut }
}

export default ModalWorkingAntiLogout